
import Cart from '../containers/Cart'
import Checkout from '../containers/Checkout'
import Payment from '../containers/Payment'
import Address from '../containers/Address'
import AddressCreate from '../containers/AddressCreate'
import Success from '../containers/Success'
import TermsAndConditions from '../../components/TermsAndConditions'

export default {
  path: '/cart',
  name: 'CartContainer',
  component: {
	render(c) { return c('router-view') }
  },
  children: [
	{
		path: '/',
		name: 'Cart',
		component: Cart,
	},
	{
		path: 'checkout',
		name: 'Shopping Cart',
		component: Checkout,
	},
	{
		path: 'payment',
		name: 'Payment',
		component: Payment,
		props: true
	},
	{
		path: 'payment/success',
		name: 'Success',
		component: Success,
	},
	{
		path: 'address',
		name: 'Address',
		component: Address,
	},
	{
		path: 'address/create',
		name: 'Address Create',
		component: AddressCreate,
		props: true
	},
	{
		path: 'termsAndConditions',
		name: 'Terms and Conditions',
		component: TermsAndConditions
	}
  ]
}





// WEBPACK FOOTER //
// ./src/Cart/route/index.js